import { useMemo } from 'react';
import type { Answer, SourceDocument } from "@/components/types";
import { enrichSourceDocuments } from "@/utils/enrichSourceDocuments";

/**
 * Hook to enrich source documents with quotes and answer reference flags
 * @param answer - The Answer object containing sections with document references
 * @param sourceDocuments - Array of SourceDocument objects to enrich
 * @returns Array of enriched SourceDocument objects
 */
export const useEnrichedSourceDocuments = (
  answer: Answer | null,
  sourceDocuments: SourceDocument[]
): SourceDocument[] => {
  return useMemo(() => {
    if (!answer) {
      return sourceDocuments;
    }
    
    return enrichSourceDocuments(answer, sourceDocuments);
  }, [answer, sourceDocuments]);
};
